import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { StoreService } from '../../store/store.service';

export const clothingDetailResolver: ResolveFn<void> = async (
  route: ActivatedRouteSnapshot,
) => {
  const store = inject(StoreService);
  const {
    clothing: { setActiveClothing },
  } = store.getActions();

  await setActiveClothing(+route.paramMap.get('id')!);

  return;
};
